import { useEffect } from "react";
import { lockInstalledPwaToPortrait } from "../services/pwaDisplayMode";

export default function useInstalledPwaPortraitLock({ enabled = true } = {}) {
  useEffect(() => {
    if (!enabled || typeof window === "undefined") {
      return undefined;
    }

    const lockPortrait = () => {
      lockInstalledPwaToPortrait().catch(() => {});
    };

    lockPortrait();
    window.addEventListener("orientationchange", lockPortrait);
    window.addEventListener("resize", lockPortrait);
    document.addEventListener("fullscreenchange", lockPortrait);
    document.addEventListener("visibilitychange", lockPortrait);

    return () => {
      window.removeEventListener("orientationchange", lockPortrait);
      window.removeEventListener("resize", lockPortrait);
      document.removeEventListener("fullscreenchange", lockPortrait);
      document.removeEventListener("visibilitychange", lockPortrait);
    };
  }, [enabled]);
}
